// eslint-disable-next-line import/prefer-default-export
export const templateNames = ['Default', 'Editorial', 'KPE'] as const;

export const DARK_BACKGROUNDS = ['lakePoppy', 'lemonPoppy', 'sagePoppy', 'lavenderPoppy', 'charcoal', 'eggplant', 'sage'];
export const LIGHT_BACKGROUNDS = ['lightSandPoppy', 'poppy', 'lightSand', 'white', 'stone', 'sky', 'cotton', 'orange', 'pink', 'yellow', 'coolGray', 'violet'];
export const BACKGROUNDS = DARK_BACKGROUNDS.concat(LIGHT_BACKGROUNDS);

export const BACKGROUND_GRADIENTS = ['lakePoppy', 'lemonPoppy', 'sagePoppy', 'lavenderPoppy', 'lightSandPoppy'];
